import { Undefinable } from 'providence-types';

export const normalize = (value: string): Undefinable<number> => {
  const newValue = parseInt(value, 10);

  return Number.isNaN(newValue) ? undefined : newValue;
};
